'use client';

import { c as _c } from "react/compiler-runtime";
import { LinkList, LinkListItem, Picture, PrimaryNav, TextLink } from '@petsmart-ui/sparky';
import type { MouseEvent } from 'react';
import { dataLayerPush, getBaseUrlJoined, trackMainNavLinkClick } from '@libs/analytics';
import { usePageLayout } from '@libs/common-next';
import { handleServiceClick } from '@libs/experience-api';
import { type CategoryTypes, type RecursiveMenuProps } from './types';
import { getCategoryPath, trackCategoryPath, trackingData } from './utils';
export function RecursiveMenu(t0) {
  const $ = _c(6);
  const {
    parentCategory,
    parentCategories,
    path
  } = t0;
  const {
    isAuthenticated,
    isSoftAuthenticated
  } = usePageLayout();
  let t1;
  if ($[0] !== isAuthenticated || $[1] !== isSoftAuthenticated || $[2] !== parentCategories || $[3] !== parentCategory || $[4] !== path) {
    t1 = parentCategories?.filter(_temp).map(category_0 => {
      const {
        sysId,
        type: t2,
        displayText,
        shopAllCategory,
        link,
        imageUrl,
        categories,
        wrapListItems
      } = category_0;
      const type = t2 === undefined ? "text" : t2;
      const categoryPath = getCategoryPath(path, displayText);
      const handleOnClick = function handleOnClick(event) {
        handleServiceClick({
          authType: isAuthenticated,
          event,
          link,
          isSoftAuthenticated
        });
        trackMainNavLinkClick(trackCategoryPath(categoryPath));
        dataLayerPush(trackingData({
          selection: `${parentCategory} | ${displayText}`,
          link_url: getBaseUrlJoined(link)
        }));
      };
      if (!categories?.length) {
        if (shopAllCategory) {
          return null;
        }
        if (type === "image") {
          return <PrimaryNav.Item key={`${sysId}-${parentCategory}`} className={`category__item--${type}`}><TextLink href={link} onClick={event_0 => handleOnClick(event_0)} title={displayText} id={displayText}><Picture imgSrc={imageUrl ?? ""} imgAlt={displayText ?? ""} imageComponentProps={{
                loading: "lazy"
              }} /><span className="sparky-u-is-vishidden">{displayText}</span></TextLink></PrimaryNav.Item>;
        }
        return <PrimaryNav.Item key={`${sysId}-${parentCategory}`} className={`category__item--${type}`}><TextLink href={link} variant="secondary" onClick={event_1 => handleOnClick(event_1)} id={displayText}>{displayText}</TextLink></PrimaryNav.Item>;
      }
      return <PrimaryNav.Item key={`${sysId}-${parentCategory}`} className={`category__list--${type}`}><LinkList className={wrapListItems ? "is-legacy-grid" : ""}><LinkListItem onClick={event_2 => handleOnClick(event_2)} href={link} text={displayText} /><RecursiveMenu parentCategory={`${parentCategory} | ${displayText}`} parentCategories={categories} path={categoryPath} wrapListItems={Boolean(wrapListItems)} /></LinkList></PrimaryNav.Item>;
    });
    $[0] = isAuthenticated;
    $[1] = isSoftAuthenticated;
    $[2] = parentCategories;
    $[3] = parentCategory;
    $[4] = path;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function _temp(category, index, self) {
  return index === self.findIndex(c => c.sysId === category.sysId);
}